module.exports = __webpack_public_path__ + "static/img/tx3.0b051c7e.png";